import SearchPageModel from '@/js/desktop/Domain/Model/SearchPageModel';
import HotelCategoriesRepository from '@/js/common/Domain/Repository/HotelCategories';
import MealsRepository from '@/js/common/Domain/Repository/Meals';
import popoverStackView from '@/js/desktop/components/popoverStack/popoverStack';

import template from './template.html';
import './ApplyFiltersPopover.css';

const facilities = {
    beachType: '',
    firstLine: '1-я линия',
    secondLine: '2-я линия',
    thirdLine: '3-я линия',
    beachOwner: 'Собственный пляж отеля',
    isExclusive: 'Эксклюзивно на Travelata',
    sandBeach: 'Песчаный пляж',
    pebbleBeach: 'Галечный пляж',
    children_animators: 'Детская анимация',
    children_pool: 'Детский бассейн',
    children_waterslides: 'Водные горки',
    children_aquapark: 'Аквапарк',
    children_seaEnter: 'Удобный вход в море',
    children_childmenu: 'Детское меню',
    children_childBed: 'Детские кроватки',
    children_nanny: 'Услуги няни (платно)',
    children_clubs: 'Детские мини-клубы',
    withKids: 'Отдых с детьми',
    adultsOnly: 'Для взрослых',
    forCouples: 'Идеально для пар',
    nearTheLift: 'Близко к подъемнику',
    excursions: 'Экскурсионные программы',
    airConditioner: 'Кондиционер',
    nearTheBeach: 'Близко к пляжу',
    nearTheCenter: 'Близко к центу',
    spa: 'Спа',
    withAnimals: 'Отдых с животными',
    mountains: 'В горах',
    eco: 'Эко отель',
    swimmingPool: 'Бассейн',
    wifi: 'Интернет',
    wellness: 'Оздоровительные туры',
    pool: 'С бассейном',
    animation: 'Анимация',
    familyRooms: 'Семейные номера',
    diving: 'Дайвинг',
    freeSafe: 'Бесплатный сейф',
    fitnessCenter: 'Фитнес-центр',
    freeMiniBar: 'Бесплатный мини-бар',
    skiEquipment: 'Горнолыжное снаряжение',
    honeyMoon: 'Для медового месяца',
    waterSports: 'Водные виды спорта',
    spaAndHealth: 'SPA и оздоровительный центр',
    nightClub: 'Ночной клуб',
    personsWithDisabilities: 'Для гостей с ограниченными физ. возможностями',
    noSmokingRooms: 'Номера для некурящих',
    smokingRooms: 'Номера для курящих',
    openPool: 'Открытый бассейн',
    closePool: 'Крытый бассейн',
    heatedPool: 'Бассейн с подогревом',
    seaPool: 'Бассейн с морской водой',
    kidsPool: 'Детский бассейн',
    waterslides: 'Водные горки',
    aquapark: 'Аквапарк',
    saunaBathHammam: 'Сауна / Баня / Хаммам',
    jacuzzi: 'Джакузи',
    freeCancellation: 'Бесплатная отмена',
    lonelyMan: 'Принимает одиноких мужчин',
    cashback: 'Кэшбек 20%',
};
const rating = {
    best: 'Превосходно',
    better: 'Очень хорошо',
    good: 'Хорошо',
    satisfactorily: 'Удовлетворительно',
};
const hideCountdown = 20000;

const ApplyFiltersViewModel = Backbone.Epoxy.Model.extend({
    defaults: {
        searchPageModel: null,
        previousFilterCriteria: null,
        previousMeals: null,
        previousHotelCategories: null,
        currentFilterCriteria: null,
        currentMeals: null,
        currentHotelCategories: null,
        applyHotelCategories: true,
        applyMeals: true,
        applyBudget: true,
        applyFacilities: true,
        applyRating: true,
    },
    computeds: {
        differentHotelCategories: {
            deps: ['previousHotelCategories', 'currentHotelCategories'],
            get(previousHotelCategories, currentHotelCategories) {
                let hasDifference = false;
                if (previousHotelCategories && currentHotelCategories && previousHotelCategories.manuallyChanged) {
                    hasDifference = previousHotelCategories.length !== currentHotelCategories.length
                        || _.intersection(previousHotelCategories.models, currentHotelCategories.models).length !== previousHotelCategories.length;
                }
                return hasDifference;
            },
        },
        differentHotelCategoriesText: {
            deps: ['previousHotelCategories', 'differentHotelCategories'],
            get(previousHotelCategories, differentHotelCategories) {
                return differentHotelCategories && previousHotelCategories.length ? previousHotelCategories.pluck('name').join(', ') : 'Любой';
            },
        },
        differentMeals: {
            deps: ['previousMeals', 'currentMeals'],
            get(previousMeals, currentMeals) {
                let hasDifference = false;
                if (previousMeals && currentMeals && previousMeals.manuallyChanged) {
                    hasDifference = previousMeals.length !== currentMeals.length
                        || _.intersection(previousMeals.models, currentMeals.models).length !== previousMeals.length;
                }
                return hasDifference;
            },
        },
        differentMealsText: {
            deps: ['previousMeals', 'differentMeals'],
            get(previousMeals, differentMeals) {
                return differentMeals && previousMeals.length
                    ? previousMeals.map((meal) => `${meal.get('code')} - ${meal.get('name')}`).join(', ')
                    : 'Любое';
            },
        },
        differentFacilities: {
            deps: ['previousFilterCriteria', 'currentFilterCriteria'],
            get(previousFilterCriteria, currentFilterCriteria) {
                const differentFacilities = [];

                if (previousFilterCriteria && currentFilterCriteria) {
                    _.each(facilities, (value, attribute) => {
                        if (previousFilterCriteria.get(attribute) !== currentFilterCriteria.get(attribute)) {
                            differentFacilities.push(attribute);
                        }
                    });
                }
                return differentFacilities.length ? differentFacilities : false;
            },
        },
        differentFacilitesText: {
            deps: ['differentFacilities', 'previousFilterCriteria'],
            get(differentFacilities, previousFilterCriteria) {
                return differentFacilities ? _.map(differentFacilities, (facility) => {
                    if (facility === 'beachType') {
                        return facilities[previousFilterCriteria.get(facility)];
                    }
                    return facilities[facility];
                }).join(', ') : '';
            },
        },
        differentRating: {
            deps: ['previousFilterCriteria', 'currentFilterCriteria'],
            get(previousFilterCriteria, currentFilterCriteria) {
                const differentRating = [];
                if (previousFilterCriteria && currentFilterCriteria) {
                    _.each(rating, (value, attribute) => {
                        if (previousFilterCriteria.get(attribute) !== currentFilterCriteria.get(attribute)) {
                            differentRating.push(attribute);
                        }
                    });
                }
                return differentRating.length ? differentRating : false;
            },
        },
        differentRatingText: {
            deps: ['previousFilterCriteria', 'differentRating'],
            get(previousFilterCriteria, differentRating) {
                return differentRating ? _.map(differentRating, (ratingCategory) => rating[ratingCategory]).join(', ') : '';
            },
        },

        differentBudget: {
            deps: ['previousFilterCriteria', 'currentFilterCriteria', 'searchPageModel'],
            get(previousFilterCriteria, currentFilterCriteria, searchPageModel) {
                let differentBudget = false;
                let minPrice;
                let maxPrice;
                let defaultMinPrice;
                let defaultMaxPrice;
                let unfilteredMinPrice;
                let unfilteredMaxPrice;

                if (previousFilterCriteria && currentFilterCriteria) {
                    minPrice = previousFilterCriteria.get('minPrice');
                    maxPrice = previousFilterCriteria.get('maxPrice');
                    defaultMinPrice = searchPageModel.get('defaultMinPrice');
                    defaultMaxPrice = searchPageModel.get('defaultMaxPrice');
                    unfilteredMinPrice = searchPageModel.get('unfilteredMinPrice');
                    unfilteredMaxPrice = searchPageModel.get('unfilteredMaxPrice');

                    if (minPrice !== defaultMinPrice && minPrice > unfilteredMinPrice) {
                        differentBudget = differentBudget || {};
                        differentBudget.minPrice = minPrice;
                    }

                    if (maxPrice !== defaultMaxPrice && maxPrice < unfilteredMaxPrice) {
                        differentBudget = differentBudget || {};
                        differentBudget.maxPrice = maxPrice;
                    }
                }

                return differentBudget;
            },
        },
        differentBudgetText: {
            deps: ['differentBudget'],
            get(differentBudget) {
                let differentBudgetText = '';

                if (differentBudget) {
                    if (differentBudget.minPrice) {
                        differentBudgetText += `от ${differentBudget.minPrice.formatNumber()}`;
                    }

                    if (differentBudget.maxPrice) {
                        differentBudgetText += ` до ${differentBudget.maxPrice.formatNumber()}`;
                    }
                }

                differentBudgetText += ' руб';

                return differentBudgetText;
            },
        },
        enableFiltersPopover: {
            deps: ['differentHotelCategories', 'differentMeals', 'differentFacilities', 'differentRating', 'differentBudget', 'searchPageModel', 'previousFilterCriteria'],
            get(differentHotelCategories, differentMeals, differentFacilities, differentRating, differentBudget, searchPageModel, previousFilterCriteria) {
                let availability = differentHotelCategories || differentMeals;
                let searchPageModelForCheck;

                if ((differentFacilities || differentBudget || differentRating) && !differentHotelCategories && !differentMeals) {
                    searchPageModelForCheck = new SearchPageModel({
                        syncHotels: searchPageModel.get('syncHotels'),
                        filterCriteria: previousFilterCriteria,
                    });

                    availability = searchPageModelForCheck.get('filteredHotels').length;
                }

                return availability;
            },
        },
        atLeastOneFilterSelected: {
            deps: ['differentHotelCategories', 'differentMeals', 'differentFacilities', 'differentRating', 'differentBudget',
                'applyHotelCategories', 'applyMeals', 'applyBudget', 'applyFacilities', 'applyRating'],
            get(differentHotelCategories, differentMeals, differentFacilities, differentRating, differentBudget,
                applyHotelCategories, applyMeals, applyBudget, applyFacilities, applyRating) {
                return (differentHotelCategories && applyHotelCategories)
                    || (differentMeals && applyMeals)
                    || (differentBudget && applyBudget)
                    || (differentFacilities && applyFacilities)
                    || (differentRating && applyRating);
            },
        },
    },
});

const ApplyFiltersPopoverView = Backbone.Epoxy.View.extend({
    el: template(),
    waitTours: null,
    events: {
        'click .applyFilterPopover__applyButton': 'applySelectedFilters',
        'click .applyFilterPopover__discardButton': 'closePopover',
    },
    bindings: {
        '.applyFilterPopover__hotelCategory': 'toggle:differentHotelCategories',
        '.applyFilterPopover__hotelCategory label': 'classes:{checked:applyHotelCategories}',
        '.applyFilterPopover__hotelCategory input': 'checked:applyHotelCategories',
        '.applyFilterPopover__hotelCategory .applyFilterPopover__value': 'text:differentHotelCategoriesText',

        '.applyFilterPopover__meal': 'toggle:differentMeals',
        '.applyFilterPopover__meal label': 'classes:{checked:applyMeals}',
        '.applyFilterPopover__meal input': 'checked:applyMeals',
        '.applyFilterPopover__meal .applyFilterPopover__value': 'text:differentMealsText',

        '.applyFilterPopover__budget': 'toggle:differentBudget',
        '.applyFilterPopover__budget label': 'classes:{checked:applyBudget}',
        '.applyFilterPopover__budget input': 'checked:applyBudget',
        '.applyFilterPopover__budget .applyFilterPopover__value': 'text:differentBudgetText',

        '.applyFilterPopover__facilities': 'toggle:differentFacilities',
        '.applyFilterPopover__facilities label': 'classes:{checked:applyFacilities}',
        '.applyFilterPopover__facilities input': 'checked:applyFacilities',
        '.applyFilterPopover__facilities .applyFilterPopover__value': 'text:differentFacilitesText',

        '.applyFilterPopover__rating': 'toggle:differentRating',
        '.applyFilterPopover__rating label': 'classes:{checked:applyRating}',
        '.applyFilterPopover__rating input': 'checked:applyRating',
        '.applyFilterPopover__rating .applyFilterPopover__value': 'html:differentRatingText',

        '.applyFilterPopover__applyButton': 'toggle: atLeastOneFilterSelected',
    },
    closePopover() {
        if (this.closePopoverExported) {
            this.closePopoverExported();
        }
    },
    applySelectedFilters() {
        const previousFilterCriteria = this.viewModel.get('previousFilterCriteria');
        const previousHotelCategories = this.viewModel.get('previousHotelCategories');
        const differentHotelCategories = this.viewModel.get('differentHotelCategories');
        const applyHotelCategories = this.viewModel.get('applyHotelCategories');
        const previousMeals = this.viewModel.get('previousMeals');
        const differentMeals = this.viewModel.get('differentMeals');
        const applyMeals = this.viewModel.get('applyMeals');
        const differentFacilities = this.viewModel.get('differentFacilities');
        const applyFacilities = this.viewModel.get('applyFacilities');
        const differentRating = this.viewModel.get('differentRating');
        const applyRating = this.viewModel.get('applyRating');
        const differentBudget = this.viewModel.get('differentBudget');
        const applyBudget = this.viewModel.get('applyBudget');
        let meals;
        let hotelCategories;
        let changedAttributes = [];

        if (differentFacilities && applyFacilities) {
            changedAttributes = changedAttributes.concat(differentFacilities);
        }
        if (differentRating && applyRating) {
            changedAttributes = changedAttributes.concat(differentRating);
        }
        if (differentBudget && applyBudget) {
            changedAttributes = changedAttributes.concat(['minPrice', 'maxPrice']);
        }

        const applyFilters = _.pick.apply(this, [previousFilterCriteria.attributes].concat(changedAttributes));

        if (differentHotelCategories && applyHotelCategories) {
            hotelCategories = new HotelCategoriesRepository(previousHotelCategories.models);
            hotelCategories.manuallyChanged = true;
            this.searchFormViewModel.get('hotelCategories').set('model', hotelCategories, {
                initiator: 'filtersPopover',
            });
        }

        if (differentMeals && applyMeals) {
            meals = new MealsRepository(previousMeals.models);
            meals.manuallyChanged = true;
            this.searchFormViewModel.get('meals').set('model', meals, {
                initiator: 'filtersPopover',
            });
        }

        this.filterCriteria.set(applyFilters);
        this.closePopover();
    },
    showFiltersPopover() {
        const enableFiltersPopover = this.viewModel.get('enableFiltersPopover');

        if (enableFiltersPopover) {
            setTimeout(() => {
                /*
                * Данный таймаут необходим так как событие наступает раньше change:syncHotels
                * чем change:searchData и поэтом поповер сразу же закрывается, таймаут не дает событиям поменяться местами
                * */
                this.turnOnAllPopoverFilters();
                popoverStackView.push({
                    view: this,
                    popoverClass: 'applyFilterPopover',
                    popoverTimeout: hideCountdown,
                });
            }, 100);
        }
    },
    turnOnAllPopoverFilters() {
        this.viewModel.set({
            applyHotelCategories: true,
            applyMeals: true,
            applyBudget: true,
            applyFacilities: true,
            applyRating: true,
        });
    },
    clearCurrentFilters() {
        this.viewModel.set('currentFilterCriteria', null);
        this.viewModel.set('currentMeals', null);
        this.viewModel.set('currentHotelCategories', null);
    },
    newSearchStarted() {
        this.closePopover();
    },
    waitToursLoading() {
        const syncHotels = this.searchPageModel.get('syncHotels');

        if (syncHotels && syncHotels.length && this.waitTours) {
            this.viewModel.set('currentFilterCriteria', this.filterCriteria.clone());
            this.viewModel.set('currentMeals', this.searchPageModel.get('searchData').get('meals'));
            this.viewModel.set('currentHotelCategories', this.searchPageModel.get('searchData').get('hotelCategories'));
            this.showFiltersPopover();
            this.waitTours = false;
        }
    },
    searchDataChanged() {
        this.clearCurrentFilters();

        this.viewModel.set('previousFilterCriteria', this.filterCriteria.clone());
        this.viewModel.set('previousMeals', this.searchPageModel.get('searchData').get('meals'));
        this.viewModel.set('previousHotelCategories', this.searchPageModel.get('searchData').get('hotelCategories'));
        this.waitTours = true;
    },
    initModelEvents() {
        this.searchPageModel.on('differencesFormCriteria', $.proxy(this.searchDataChanged, this));
        this.searchPageModel.on('change:syncHotels', $.proxy(this.waitToursLoading, this));
        this.searchPageModel.on('change:searchData', $.proxy(this.newSearchStarted, this));
    },
    initialize(options) {
        this.filterCriteria = options.filterCriteria;
        this.searchPageModel = options.searchPageModel;
        this.searchFormViewModel = options.searchFormViewModel;
        this.viewModel = new ApplyFiltersViewModel({
            searchPageModel: this.searchPageModel,
        });
        this.initModelEvents();
    },
});

export default ApplyFiltersPopoverView;
